import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "name", "output" ]

  connect() {
    var number_of_notifications = document.getElementById("ul_notifications").getElementsByTagName("li").length
    if (number_of_notifications > 0) {
      document.querySelector('#header-main-notifications').textContent = number_of_notifications
      document.querySelector('#header-main-notifications').classList.remove("hide")
    } else {
      document.querySelector('#no-notification-in-the-header').classList.remove("hide")
    }
  }
}